import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_GROUP_CLASS,
  TItemGroupProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemGroup: FC<TItemGroupProps> = (
  {
    className,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-component="ItemGroup"
    className={cn(ITEM_GROUP_CLASS, className)}
  >
    { children }
  </div>
);

ItemGroup.displayName = "ItemGroup";
